// extracted by mini-css-extract-plugin
module.exports = {"label":"Login_label__EbuS-","input":"Login_input__1jK98","button":"Login_button__MTDfI"};